var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      class: ["bmui-searchbox", { "bmui-searchbox-active": _vm.active }],
      on: {
        click: _vm.mixinInputDoFocus,
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "bmui-searchbox-wrap" }, [
        _c("i", { staticClass: "bmui-searchbox-icon" }),
        _vm._v(" "),
        _c(
          "input",
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.valueInside,
                  expression: "valueInside"
                }
              ],
              ref: "input",
              staticClass: "bmui-searchbox-content",
              attrs: {
                placeholder: _vm.placeholder || "请输入关键字",
                type: "text"
              },
              domProps: { value: _vm.valueInside },
              on: {
                focus: function($event) {
                  _vm.active = true
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.valueInside = $event.target.value
                }
              }
            },
            "input",
            _vm.mixinInputProps,
            false
          )
        ),
        _vm._v(" "),
        _vm.valueInside
          ? _c("button", {
              staticClass: "bmui-searchbox-del",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.valueInside = ""
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.active && _vm.valueInside
          ? _c(
              "button",
              {
                staticClass: "bmui-searchbox-submit",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [_vm._v("确 认")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.active && !_vm.valueInside
          ? _c(
              "button",
              {
                staticClass: "bmui-searchbox-submit",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.active = false
                  }
                }
              },
              [_vm._v("取 消")]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4d2eca8", { render: render, staticRenderFns: staticRenderFns })
  }
}